import type { ReactNode } from 'react';

interface Props {
  titulo: string;
  mensagem: ReactNode;
  rotuloConfirmar: string;
  confirmando?: boolean;
  aoConfirmar: () => void;
  aoCancelar: () => void;
}

export default function ModalConfirmar({
  titulo,
  mensagem,
  rotuloConfirmar,
  confirmando,
  aoConfirmar,
  aoCancelar,
}: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4">
      <div className="absolute inset-0 bg-black/40" onClick={aoCancelar} aria-hidden />
      <div className="relative z-10 w-full max-w-[400px] rounded-t-3xl bg-white p-6 pb-[calc(1.5rem+env(safe-area-inset-bottom))] sm:rounded-3xl sm:pb-6">
        <div className="flex justify-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-danger-100">
            <i className="ri-alert-line text-3xl text-danger-600" />
          </span>
        </div>
        <h3 className="mt-4 text-center text-[17px] font-semibold text-foreground-950">
          {titulo}
        </h3>
        <p className="mt-2 text-center text-[15px] leading-relaxed text-foreground-600">
          {mensagem}
        </p>
        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={aoCancelar}
            disabled={confirmando}
            className="flex min-h-[48px] flex-1 cursor-pointer items-center justify-center whitespace-nowrap rounded-2xl border border-secondary-300 bg-white text-[15px] font-semibold text-foreground-800 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={aoConfirmar}
            disabled={confirmando}
            className="flex min-h-[48px] flex-1 cursor-pointer items-center justify-center whitespace-nowrap rounded-2xl bg-danger-600 text-[15px] font-semibold text-white transition-colors hover:bg-danger-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {confirmando ? 'Removendo…' : rotuloConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
}